/**
 * @file 平滑滚动元素
 * @author FengGuang(fengguang01@baidu.com)
 *
 */
import setIntervalRaf from './set-interval-raf';

export interface IStartToScrollReturn {
    stop: () => void;
}

const startToScroll = (element: HTMLDivElement, direction: string = 'left', speed: number = (60 / 1000)): IStartToScrollReturn => {
    const handle = (() => {
        const startTime = Date.now();
        if (direction === 'right') {
            const start = element.scrollLeft;
            let point = start;
            const end = element.scrollWidth - element.clientWidth;
            return setIntervalRaf((cancel) => {
                if (point >= end) {
                    cancel();
                }
                const current = Date.now();
                const distance = Math.floor((current - startTime) * speed);

                point = start + distance;

                element.scrollTo({
                    left: Math.min(start + distance, end)
                });
            });
        }
        else if (direction === 'top') {
            const start = element.scrollTop;
            let point = start;
            const end = 0;
            return setIntervalRaf((cancel) => {
                if (point <= end) {
                    cancel();
                }
                const current = Date.now();
                const distance = Math.floor((current - startTime) * speed);

                point = start - distance;

                element.scrollTo({
                    top: Math.max(start - distance, end)
                });
            });
        }
        else if (direction === 'bottom') {
            const start = element.scrollTop;
            let point = start;
            const end = element.scrollHeight - element.clientHeight;
            return setIntervalRaf((cancel) => {
                if (point >= end) {
                    cancel();
                }
                const current = Date.now();
                const distance = Math.floor((current - startTime) * speed);

                point = start + distance;

                element.scrollTo({
                    top: Math.min(start + distance, end)
                });
            });
        }
        else {
            const start = element.scrollLeft;
            let point = start;
            const end = 0;
            return setIntervalRaf((cancel) => {
                if (point <= end) {
                    cancel();
                }
                const current = Date.now();
                const distance = Math.floor((current - startTime) * speed);

                point = start - distance;

                element.scrollTo({
                    left: Math.max(start - distance, end)
                });
            });
        }
    })();

    return {
        stop: () => {
            handle.cancel();
        }
    };
};

export default startToScroll;
